'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_DRAWER:
      return action.payload;
    case _actions.SET_APP_BAR:
      return (0, _util.merge)(state, {
        appBar: action.payload
      });
    case _actions.SET_BACK_NAVIGATION:
      return (0, _util.merge)(state, {
        appBar: (0, _util.merge)(state.appBar, {
          navigateBack: action.payload
        })
      });
    case _actions.SET_DRAWER_MENU:
      return (0, _util.merge)(state, {
        columns: action.payload
      });
    case _actions.SET_DRAWER_HEADER:
      return (0, _util.merge)(state, {
        header: action.payload
      });
    case _actions.SET_DRAWER_ITEMS:
      return (0, _util.merge)(state, {
        items: action.payload
      });
    default:
      return state;
  }
};

var _actions = require('./actions');

var _util = require('@its/util');

var initialState = {
  appBar: {
    navigateBack: false
  },
  menu: {},
  header: {},
  items: [],
  children: []
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/DrawerMenuContainer/reducer.js
 ** module id = 466
 ** module chunks = 0
 **/